import { render, staticRenderFns } from "./SetTime.vue?vue&type=template&id=32ed8238&scoped=true&"
import script from "./SetTime.vue?vue&type=script&lang=js&"
export * from "./SetTime.vue?vue&type=script&lang=js&"
import style0 from "./SetTime.vue?vue&type=style&index=0&id=32ed8238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ed8238",
  null
  
)

export default component.exports